import { Icons } from "../components/Icons.js";
import { CaptureView } from "../capture/CaptureView.js";
import type { Recording } from "../core/useRecording.js";
import type { ReactNode } from "react";

/** Écran d'accueil / capture (disposition « cartes d'action », direction C du mockup). */

interface ActionCardProps {
  icon: ReactNode;
  label: string;
  sub?: string;
  onClick: () => void;
}
function ActionCard({ icon, label, sub, onClick }: ActionCardProps) {
  return (
    <button className="acard" onClick={onClick}>
      <span className="acard-ic">{icon}</span>
      <span className="acard-tx">
        <span className="acard-label">{label}</span>
        {sub && <span className="acard-sub">{sub}</span>}
      </span>
      <span className="acard-chev">
        <Icons.Back size={20} />
      </span>
    </button>
  );
}

export interface HomeScreenProps {
  recording: Recording;
  btnScale: number;
  simple: boolean;
  usageRatio: number | null;
  bgDaily: string;
  bgStandalone: string;
  onWrite: () => void;
  onResumes: () => void;
  goNotes: () => void;
  goSettings: () => void;
  notesCount: number;
  justSaved: boolean;
}

export function HomeScreen(props: HomeScreenProps) {
  const { recording, btnScale, simple, usageRatio, bgDaily, bgStandalone, onWrite, onResumes, goNotes, goSettings, notesCount, justSaved } = props;
  return (
    <div className="screen home homeC">
      <header className="topbar">
        <div className="screen-title">Pensieve</div>
        <button className="iconbtn" onClick={goSettings} aria-label="Paramètres">
          <Icons.Gear size={22} />
        </button>
      </header>
      <div className="home-rec-c">
        <CaptureView recording={recording} btnScale={btnScale} simple={simple} usageRatio={usageRatio} bgDaily={bgDaily} bgStandalone={bgStandalone} />
      </div>
      <div className="card-stack">
        <ActionCard icon={<Icons.Pen size={22} />} label="Note écrite / photos" sub="Rédiger au clavier / ajouter des photos" onClick={onWrite} />
        <ActionCard
          icon={<Icons.List size={22} />}
          label="Mes notes"
          sub={notesCount ? `${notesCount} enregistrée${notesCount > 1 ? "s" : ""}` : "Aucune pour l'instant"}
          onClick={goNotes}
        />
        <ActionCard icon={<Icons.Doc size={22} />} label="Résumés" sub="Comptes rendus jour / semaine" onClick={onResumes} />
      </div>
      {justSaved && <div className="savedtoast">Note enregistrée</div>}
    </div>
  );
}
